import { type RaRecord, useGetIdentity, useTranslate } from "ra-core";
import { Link } from "react-router";

import { RelativeDate } from "../misc/RelativeDate";
import { useGetSalesName } from "../sales/useGetSalesName";
import type { ActivityLoadCreated } from "../types";
import { useActivityLogContext } from "./ActivityLogContext";
import { ReferenceField } from "@/components/admin/reference-field";
import { useIsMobile } from "@/hooks/use-mobile";

type ActivityLogLoadCreatedProps = {
  activity: RaRecord & ActivityLoadCreated;
};

export function ActivityLogLoadCreated({
  activity,
}: ActivityLogLoadCreatedProps) {
  const context = useActivityLogContext();
  const isMobile = useIsMobile();
  const translate = useTranslate();
  const { load } = activity;
  const { identity, isPending } = useGetIdentity();
  const isCurrentUser = !isPending && identity?.id === activity.sales_id;
  const salesName = useGetSalesName(activity.sales_id, {
    enabled: !isCurrentUser,
  });
  return (
    <div className="p-0">
      <div className="flex flex-row gap-2 items-start w-full">
        <div className="w-[20px] h-[20px] bg-gray-300 rounded-full shrink-0" />
        <span className="text-muted-foreground text-sm flex-grow">
          {translate(
            isCurrentUser
              ? "crm.activity.you_added_load"
              : "crm.activity.added_load",
            { name: salesName },
          )}{" "}
          {isMobile ? (
            load.load_number
          ) : (
            <Link to={`/loads/${load.id}/show`}>{load.load_number}</Link>
          )}{" "}
          {context !== "company" && activity.company_id && (
            <>
              {translate("crm.activity.to")}{" "}
              <ReferenceField
                source="company_id"
                reference="companies"
                record={activity}
                link="show"
              />{" "}
              <RelativeDate date={activity.date} />
            </>
          )}
          {context === "company" && (
            <RelativeDate date={activity.date} />
          )}
        </span>
        {context !== "company" && !activity.company_id && (
          <span className="text-muted-foreground text-sm">
            <RelativeDate date={activity.date} />
          </span>
        )}
      </div>
    </div>
  );
}
